import * as React from 'react'
import Icon from '../../Icon/Icon'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { inject } from 'mobx-react'
import { IUserStore } from 'src/store/UserStore'
import { ILayoutStore } from 'src/store/LayoutStore'
import { IResultStore } from 'src/store/ResultStore'
import { IWeekConsumptionStore } from 'src/store/WeekConsumptionStore'

interface IResultsRepeatTest extends RouteComponentProps<any> {
  UserStore?: IUserStore
  LayoutStore?: ILayoutStore
  ResultStore?: IResultStore
  WeekConsumptionStore?: IWeekConsumptionStore
}

@inject('UserStore', 'LayoutStore', 'WeekConsumptionStore', 'ResultStore')
class ResultsRepeatTest extends React.Component<IResultsRepeatTest> {
  public constructor(props: IResultsRepeatTest) {
    super(props)
  }
  public render() {
    return (
      <div className="ResultsRepeatTest">
        <p className="ResultsRepeatTest-text">
          Si cette semaine n'était pas représentative de votre consommation habituelle, n'hésitez
          pas à refaire le test sur une autre semaine.
        </p>
        <div
          className={`ResultsRepeatTest__control${
            this.props.ResultStore.rep1 === 0 &&
            this.props.ResultStore.rep2 === 0 &&
            this.props.ResultStore.rep3 === 0
              ? ' ResultsRepeatTest__control--green'
              : ''
          }`}
        >
          <button className="ResultsRepeatTest-btn" onClick={this.repeatTest}>
            Refaire le test
            <span>
              <Icon
                name="deplier"
                iconClass={`${
                  this.props.ResultStore.rep1 === 0 &&
                  this.props.ResultStore.rep2 === 0 &&
                  this.props.ResultStore.rep3 === 0
                    ? 'Icon--green'
                    : ''
                }`}
              />
            </span>
          </button>
        </div>
      </div>
    )
  }

  public repeatTest = () => {
    this.props.LayoutStore!.fullReset()
    this.props.UserStore!.reset()
    this.props.WeekConsumptionStore!.reset()
    this.props.ResultStore!.reset()
    this.props.history.push('/')
  }
}

export default withRouter(ResultsRepeatTest)



// WEBPACK FOOTER //
// ./src/components/ResultsComponents/ResultsRepeatTest/ResultsRepeatTest.tsx